import { render, staticRenderFns } from "./NewFQCexaminedata.vue?vue&type=template&id=0bd87d07&scoped=true"
import script from "./NewFQCexaminedata.vue?vue&type=script&lang=js"
export * from "./NewFQCexaminedata.vue?vue&type=script&lang=js"
import style0 from "./NewFQCexaminedata.vue?vue&type=style&index=0&id=0bd87d07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd87d07",
  null
  
)

export default component.exports